
import React from "react";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-grow pt-28 pb-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-3xl font-bold text-[#0c4a6e] mb-8">Política de Privacidad</h1>
          
          <div className="prose prose-blue max-w-none">
            <p className="mb-4">
              Última actualización: {new Date().toLocaleDateString('es-ES', {year: 'numeric', month: 'long', day: 'numeric'})}
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">1. Información que Recopilamos</h2>
            <p className="mb-4">
              En Gavinsurance, valoramos su privacidad y nos comprometemos a proteger sus datos personales. Esta política de privacidad describe cómo recopilamos, usamos y compartimos su información cuando visita nuestro sitio web o utiliza nuestros servicios.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">2. Uso de la Información</h2>
            <p className="mb-4">
              Utilizamos la información que recopilamos para proporcionar, mantener y mejorar nuestros servicios, para comunicarnos con usted, para fines de seguridad y para cumplir con obligaciones legales.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">3. Compartir Información</h2>
            <p className="mb-4">
              No vendemos su información personal a terceros. Podemos compartir su información con proveedores de servicios, socios comerciales, autoridades legales y en caso de una transacción corporativa.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">4. Sus Derechos</h2>
            <p className="mb-4">
              Dependiendo de su ubicación, puede tener ciertos derechos con respecto a sus datos personales, como el derecho a acceder, corregir, eliminar o restringir el procesamiento de sus datos.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">5. Cambios a esta Política</h2>
            <p className="mb-4">
              Podemos actualizar esta política de privacidad periódicamente. Le notificaremos cualquier cambio publicando la nueva política de privacidad en esta página.
            </p>
            
            <h2 className="text-xl font-semibold text-[#0c4a6e] mt-8 mb-4">6. Contacto</h2>
            <p className="mb-4">
              Si tiene alguna pregunta sobre esta política de privacidad, por favor contáctenos en:
            </p>
            <p className="mb-4">
              <strong>Email:</strong> <a href="mailto:info@gavinsurance.com" className="text-[#0284c7] hover:underline">info@gavinsurance.com</a><br />
              <strong>Teléfono:</strong> <a href="tel:+17865695142" className="text-[#0284c7] hover:underline">(888) 370-8454</a><br />
              <strong>Dirección:</strong> 7500 NW 25 ST #237, Doral, FL 33122
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
